import { Types } from "../../@types"
import React, { Fragment, createContext, useContext, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Plus, Save } from "lucide-react"
import { useAppCtx, appStore } from "lib/state"
import { queryTools, cn, randoms } from "lib/utils"
import { makeNewConditional } from "lib/utils/conditionals"
import { DialogBox, Modal, TagsManager } from "lib/components" 
import { ApiDataProvider, ApiDataManager } from "lib/units/apidata"
import { ConditionalDropZone, ConditionalClipboard, SaveConditionalModal, ConditionalWorkingArea, SpotlightItem, useConditional } from "lib/units/conditional"

// const ConditionalContext = createContext({})
// export const useConditionalCtx = () => useContext(ConditionalContext)

export const ConditionalProvider = ({ usage="statement", className="", children }:{ usage:string; className?:string; children:React.ReactNode }) => {

  const { tmplid } = useParams<{tmplid:string}>()
  const { appState }:any = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { update }:any = AppStore
  const { data:_Template } = queryTools.resource.parseQueryForApi("template.findById", { _id: tmplid })
  const saveFn = queryTools.resource.save(["conditional.all"])

  async function handleConditionalSave(e:any, data:any){
    if(e) e.preventDefault()
    console.log(data)
    saveFn.mutate({ resource: "conditional", data: {...data, _id: data._id} })
  }

  // const defaultConditional = {
  //   "source_id": null,
  //   name: "",
  //   description: "",
  //   clipboard: [],
  //   items: []
  // }

  // const makeNewConditional = () => {
  //   const newZoneRef = randoms.string(12, "a#")
  //   const newZone = { zoneref: newZoneRef, groups: [] }
  //   return {...defaultConditional, zones: [newZone]}
  // }

  const [ currentConditional, setCurrentConditional ] = useState<any>(null)

  const updateConditional = (data:any) => {
    console.log("data", data)
    if( !data ) data = makeNewConditional()
    if( usage === "statement" ){
      return update("actives.statement.conditional", {...store.actives.statement.conditional, ...data })
    } else {
      return update("actives.conditional", {...store.actives.conditional, ...data })
    }
  }
  

  useEffect(() => {
    let current 
    if( usage === "statement" ){
      if( !store.actives.statement.conditional ){
        const cond = makeNewConditional()
        update("actives.statement.conditional", cond)
        current = cond
      } else {
        current = store.actives.statement.conditional
      }
    } else if (usage === "conditional"){
      if( !store.actives.conditional ){
        const cond = makeNewConditional()
        update("actives.conditional", cond)
        current = cond
      } else {
        current = store.actives.conditional
      }
    }
    setCurrentConditional(current)
  },[store.actives.statement?.conditional, store.actives.conditional, usage])

  return ( 
    // <ConditionalContext.Provider value={{ usage, currentConditional, makeNewConditional, updateConditional, handleConditionalSave }}>
      <div className={cn("w-full h-full flex justify-start items-start gap-2", className)}>
        { children }
      </div>
    // </ConditionalContext.Provider>
  )
}